import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import store from '../../store';
import axios from "axios";

export default {
  name: "GradeFeeList",

  components: {
    MainLayout,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      search_status: false,
      campusGradeArr: null,
      selectedGrade: 0,
      selectedCampusGrade: 0,
      searchData: [],
      gradeFeeMasterData: {},
      searchBtnStatus: false,
      searchedData: null,
      isSearched: false,
      currentAcdYearId: null,
      campus_grade_id: null,
    };
  },

  methods: {
    getCampusGradeName() {
      axios.get('getAcademicYearCampusGradeName', {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        let $defaultSelectOption = [{
          "id": 0,
          "text": "All"
        }];
        this.campusGradeArr = $defaultSelectOption.concat(res.data);
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    reset() {
      this.selectedCampusGrade = 0;
      this.searchData = [];
      this.isLoading = true;
      this.getCurrentYearGradeFee();
      this.isSearched = false;
    },

    searchGradeFee(page = 1) {
      this.search_status = true;
      this.isLoading = true;
      const params = {
        campus_grade_id: this.selectedCampusGrade,
        annual_fee: this.searchData.annual_fee,
        monthly_fee: this.searchData.monthly_fee,
        campus_id: store.state.user.campus_id,
      };
      this.searchedData = {
        ...params,
        search_status: this.search_status,
      };
      this.isSearched = true;

      axios.get('gradeFee/search?page=' + page, { params })
        .then(res => {
          if (res.data) {
            this.gradeFeeMasterData = res.data;
          }
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response?.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);
    },

    selectEvent({
      id
    }, fieldName) {
      id == 'Select' ? this.$set(this, fieldName, '') : this.$set(this, fieldName, id);
    },

    getCurrentYearGradeFee(page = 1) {
      this.search_status = false;
      axios.get('period/getThisPeriod')
        .then(res => {
          this.currentAcdYearId = res.data.id;
          this.isLoading = false;
          axios.get('gradeFee/list?page=' + page, {
            params: {
              campus_id: store.state.user.campus_id,
              acd_year_id: this.currentAcdYearId
            }
          }).then((response) => {
            this.gradeFeeMasterData = response.data;
            this.isLoading = false;
          })
            .catch((error) => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            });

        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });

    },

    showCreate() {
      this.$router.push({
        path: "/gradeFee/create"
      });
    },

    showEdit(gradeFeeId) {
      this.$router.push({
        name: "gradeFeeEdit",
        params: {
          id: gradeFeeId
        }
      });
    },

    showDetail(gradeFeeId) {
      this.$router.push({
        name: "gradeFeeDetail",
        params: {
          id: gradeFeeId
        }
      });
    },

    confirmDelete(gradeFeeId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteGradeFee(gradeFeeId);
      } else {
        console.log("no");
      }
    },

    deleteGradeFee(gradeFeeId) {
      this.isLoading = true;
      axios.delete("/gradeFee/delete/" + gradeFeeId)
        .then(response => {
          if (response.data.success == true) {
            this.getCurrentYearGradeFee();
            this.$notification.success('Grade Fee Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            this.$notification.error("Grade fee data is already deleted.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.getCurrentYearGradeFee();
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.error("Grade Fee Delete Error->", error.response.data);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : { campus_id: store.state.user.campus_id, acd_year_id: this.currentAcdYearId };
      axios.get('/gradeFee/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `grade_fee_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getCurrentYearGradeFee();
    this.getCampusGradeName();
  },
};
